import React from "react";
import {IonButton, IonIcon, IonItem, IonLabel, IonList, IonSpinner} from "@ionic/react";
import {checkmarkCircle, closeCircle} from "ionicons/icons";
import {FazendaObject, getFazendaNomeCompleto} from "../../../models/Fazenda";

interface CalendarioHomeProps {
  fazenda: FazendaObject;
  setSecaoAtiva: (secao: string) => void;
  produtosOk: boolean;
  rebanhoOk: boolean;
  calendarioOk: boolean;
  onConcluir: () => void;
  gravando: boolean;
}

const CalendarioHome: React.FC<CalendarioHomeProps> = (props) => {
  return (
    <>
      <div className="font-bold text-xl">
        {getFazendaNomeCompleto(props.fazenda)}
      </div>

      <IonList className="mt-6 flex-grow">
        <IonItem
          button={true}
          onClick={() => props.setSecaoAtiva('produtos')}
          disabled={props.gravando}
        >
          <IonLabel>
            Produtos
          </IonLabel>
          <IonIcon
            slot="start"
            color={props.produtosOk ? 'success' : 'danger'}
            icon={
              props.produtosOk ? checkmarkCircle : closeCircle
            }
          />
        </IonItem>

        <IonItem
          button={true}
          onClick={() => props.setSecaoAtiva('rebanho')}
          disabled={props.gravando}
        >
          <IonLabel>
            Rebanho
          </IonLabel>
          <IonIcon
            slot="start"
            color={props.rebanhoOk ? 'success' : 'danger'}
            icon={
              props.rebanhoOk ? checkmarkCircle : closeCircle
            }
          />
        </IonItem>

        <IonItem
          button={true}
          onClick={() => props.setSecaoAtiva('calendario')}
          disabled={!props.produtosOk || !props.rebanhoOk || props.gravando}
        >
          <IonLabel>
            Calendário de aplicações
          </IonLabel>
          <IonIcon
            slot="start"
            color={props.calendarioOk ? 'success' : 'danger'}
            icon={
              props.calendarioOk ? checkmarkCircle : closeCircle
            }
          />
        </IonItem>
      </IonList>

      {props.gravando &&
        <div className="flex justify-center mt-6">
          <IonSpinner/>
        </div>
      }
      <div className="flex justify-center mt-16">
        <IonButton
          disabled={!props.produtosOk || !props.rebanhoOk || !props.calendarioOk || props.gravando}
          onClick={props.onConcluir}
        >
          Preparar calendário sanitário
        </IonButton>
      </div>
    </>
  );
}

export default CalendarioHome;
